import { createSelector } from 'reselect';
import { compose, map, sortBy, pick } from 'lodash/fp';
import { Option } from '@mews-commander/legacy-data-structures';
import { getCurrencies as getCurrenciesSelector } from '@mews-commander/core/legacy-globalization';
import { getCurrentEnterpriseAcceptedCurrencyCodes } from '../selectors/session/enterprise';
import { getEnterpriseAcceptedCurrencyCodes } from './enterprises';

const toCurrencyOptions = compose(
    sortBy('label'),
    map(({ code }) => Option({ value: code, label: code }))
);

export const toCurrencyOptionsFromArray = compose(
    toCurrencyOptions,
    map((c) => ({ code: c }))
);

// @ts-expect-error $TSFixMeError: No overload matches this call.
const getAllCurrencies = createSelector(getCurrenciesSelector, map(pick(['code'])));

// @ts-expect-error $TSFixMeError: No overload matches this call.
export const getAllCurrencyOptions = compose(toCurrencyOptions, getAllCurrencies);
export const getCurrentEnterpriseCurrencyOptions = compose(
    toCurrencyOptionsFromArray,
    getCurrentEnterpriseAcceptedCurrencyCodes
);

export const getEnterpriseCurrencyOptions = createSelector(
    getEnterpriseAcceptedCurrencyCodes,
    toCurrencyOptionsFromArray
);
